import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import bcrypt from "bcryptjs";
import { AuthContext } from "../utils/AuthContext";
import "../styles/LoginForm.css"; // Import CSS specific to the login page
import logo from "../assets/images/NZ-Pure-Dairy-Logo.svg";
import Footer from "../components/Footer";

const LoginForm = () => {
  const navigate = useNavigate();
  const { handleLogin } = useContext(AuthContext);
  const [formData, setFormData] = useState({
    username: "",
    password: ""
  });
  const [showPassword, setShowPassword] = useState(false);

  // Preset username
  const storedUsername = "admin";
  // Pre-hashed password 
  const storedHashedPassword =
    "$2b$10$a8bp59EB3avzLKBbb6Bd5OKtHNTMj0fQGyc2UE8klGi08vdswz5Zy";

  const onSubmit = (e) => {
    e.preventDefault();
    if (formData.username === storedUsername) {
      // Compare user-entered password with stored hash
      bcrypt.compare(formData.password, storedHashedPassword, (err, isMatch) => {
        if (err) {
          console.error("Password verification error:", err);
          return;
        }
        if (isMatch) {
          handleLogin(true);
          navigate("/admin");
        } else {
          alert("Incorrect username or password");
        }
      });
    } else {
      alert("Incorrect username or password");
    }
  };

  return (
    <div className="login-page">
      <header className="login-header">
        <img src={logo} alt="NZ Pure Dairy Logo" className="header-logo" />
        <h1>NZ Pure Dairy QR Code Traceability System</h1>
      </header>
      <div className="login-container">
        <div className="login-card">
          <h2>Login</h2>
          <form onSubmit={onSubmit}>
            <div className="form-group">
              <label>Username:</label>
              <input
                type="text"
                value={formData.username}
                onChange={(e) =>
                  setFormData((prev) => ({ ...prev, username: e.target.value }))
                }
              />
            </div>
            <div className="form-group">
              <label>Password:</label>
              <div className="password-wrapper">
                <input
                  type={showPassword ? "text" : "password"}
                  value={formData.password}
                  onChange={(e) =>
                    setFormData((prev) => ({ ...prev, password: e.target.value }))
                  }
                />
                <button
                  type="button"
                  className="toggle-password"
                  onClick={() => setShowPassword((prev) => !prev)}
                >
                  {showPassword ? "Hide" : "Show"}
                </button>
              </div>
            </div>
            <button type="submit" className="login-button">
              Login
            </button>
          </form>
        </div>
      </div>
      <footer className="login-footer">
        <Footer />
      </footer>
    </div>
  );
};

export default LoginForm;
